var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.75 61.5897C49.2829 61.5897 61.875 48.9979 61.875 33.4647C61.875 17.9318 49.2829 5.33984 33.75 5.33984C18.217 5.33984 5.625 17.9318 5.625 33.4647C5.625 48.9979 18.217 61.5897 33.75 61.5897Z",
    fill: "#A1FBC3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1056 33.75L35.8587 32.2594V22.725H36.8712C39.1493 22.725 41.0056 24.7219 41.0056 27.1688C41.0056 28.3219 41.9618 29.2781 43.115 29.2781C44.2681 29.2781 45.2243 28.3219 45.2243 27.1688C45.2243 22.3875 41.4837 18.5063 36.8712 18.5063H35.8587V16.875C35.8587 15.7219 34.9025 14.7656 33.7493 14.7656C32.5962 14.7656 31.64 15.7219 31.64 16.875V18.5063H29.8118C25.6492 18.5063 22.2461 22.0219 22.2461 26.325C22.2461 31.3594 25.1711 32.9625 27.393 33.75L31.64 35.2406V44.7469H30.6275C28.3493 44.7469 26.493 42.75 26.493 40.3031C26.493 39.15 25.5367 38.1938 24.3836 38.1938C23.2305 38.1938 22.2742 39.15 22.2742 40.3031C22.2742 45.0844 26.0148 48.9656 30.6275 48.9656H31.64V50.625C31.64 51.7781 32.5962 52.7344 33.7493 52.7344C34.9025 52.7344 35.8587 51.7781 35.8587 50.625V48.9938H37.6868C41.8493 48.9938 45.2525 45.4781 45.2525 41.175C45.2243 36.1125 42.2993 34.5094 40.1056 33.75ZM28.7993 29.7844C27.3648 29.2781 26.493 28.8 26.493 26.3531C26.493 24.3563 27.9836 22.7531 29.84 22.7531H31.6681V30.7969L28.7993 29.7844ZM37.6868 44.775H35.8587V36.7313L38.6993 37.7156C40.1337 38.2219 41.0056 38.7 41.0056 41.1469C41.0056 43.1438 39.515 44.775 37.6868 44.775Z",
    fill: "#2FF77A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollarIcon.85d24822246df728e7da4df8bb0927f5.svg";
export { ForwardRef as ReactComponent };